import Joi from '@hapi/joi'

export const csvFileSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select the Valid Group`,
        "any.required": `Group required`
    }),

    estateID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Please Select the Valid Estate`,
        "any.required": `Estate required`
    }),

    collectionPointCategoryID: Joi.number().invalid().required().label("Division Name").messages({
        "any.invalid": `Please Select the Valid Division`,
        "any.required": `Division required`
    }),
    searchDate: Joi.string().invalid("").required().label("Search Date").messages({
        "any.required": `Date required`
    })
}














